import { Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import FlowSummary from "./FlowSummary";
import FlowStepper from "./FlowStepper";

// One getOne powers this whole page: the flow arrives with its steps nested, and each step with the metadata
// of every HTTP attempt it made. Only the request/response *bodies* need a second call, and they load lazily
// per step because they sit behind their own permission.
const NacidFlowShow = () => (
  <Show
    title="НАЦИД поток"
    actions={<BackButtonToolbar />}
  >
    <SimpleShowLayout>
      <FlowSummary />
      <FlowStepper />
    </SimpleShowLayout>
  </Show>
);

export default NacidFlowShow;
